var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Icon from '../../../icon';
import { NavigationContext } from '../../provider';
import { NavigationToggleContainer } from './styles/navigation-toggle.styled';
export const NavigationToggle = (_a) => {
    var { children, onClick, dataTest = 'navigation-toggle' } = _a, props = __rest(_a, ["children", "onClick", "dataTest"]);
    const { navigationIsOpen, setNavigationIsOpen, activeActionReference, setActiveActionReference } = useContext(NavigationContext);
    const isLoginState = activeActionReference === 'login';
    const handleClick = (e) => {
        if (isLoginState) {
            setActiveActionReference(null);
        }
        else {
            setNavigationIsOpen(!navigationIsOpen);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (_jsxs(NavigationToggleContainer, Object.assign({ size: "small", "$isActive": isLoginState || navigationIsOpen || !activeActionReference, "$navigationIsOpen": isLoginState || navigationIsOpen, "$loginMenuIsOpen": activeActionReference === 'login', onClick: handleClick, "data-test": dataTest }, props, { color: "tertiary" }, (isLoginState || navigationIsOpen
        ? {
            'aria-label': isLoginState ? 'Sluit inlogmenu' : 'Sluit menu',
        }
        : {}), { children: [_jsx(Icon, { variant: isLoginState || navigationIsOpen ? 'cross' : 'menu', size: "lg" }), !isLoginState && children] })));
};
